import * as React from 'react';
import { Pagination, Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import './style.scss';

import PrevIcon from './icons/prev.inline.svg';
import NextIcon from './icons/next.inline.svg';

const CardCarousel = props => {
  const paginationRef = React.useRef(null);
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);

  return (
    <div className="card-carousel">
      <Swiper
        modules={[Pagination, Navigation, A11y]}
        slideToClickedSlide
        centeredSlides
        loop
        navigation={{
          prevEl: navigationPrevRef.current,
          nextEl: navigationNextRef.current,
        }}
        pagination={{
          el: paginationRef.current,
          clickable: true,
        }}
        loopedSlides={3}
        grabCursor
        onBeforeInit={swiper => {
             swiper.params.navigation.prevEl = navigationPrevRef.current;
             swiper.params.navigation.nextEl = navigationNextRef.current;
             swiper.params.pagination.el = paginationRef.current;
        }}
      >
        {props.children.map((card, i) => (
          <SwiperSlide key={i}>{card}</SwiperSlide>
        ))}

        <div className="swiper-navigation">
          <button ref={navigationPrevRef}>
            <PrevIcon />
            <span className="sr-only">Previous slide</span>
          </button>
          <div ref={paginationRef} className="swiper-pagination" />
          <button ref={navigationNextRef}>
            <NextIcon />
            <span className="sr-only">Next slide</span>
          </button>
        </div>
      </Swiper>
    </div>
  );
};

export default CardCarousel;
